var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import OrderAPI from '../API/OrderAPI';
import { PurchaseError } from './Errors/PurchaseError';
import Bugsnag from '@bugsnag/js';
import apiClient from '../API/InkyAPI';
var PurchaseAttempt = /** @class */ (function () {
    function PurchaseAttempt() {
    }
    /**
     * Create the purchase in the back-end
     */
    PurchaseAttempt.prototype.createPurchase = function () {
        return __awaiter(this, void 0, void 0, function () {
            var confirmedPurchase, e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, OrderAPI.purchase(this.purchase)];
                    case 1:
                        confirmedPurchase = _a.sent();
                        return [2 /*return*/, Object.assign(new PurchaseAttempt(), this, {
                                purchase: confirmedPurchase,
                            })];
                    case 2:
                        e_1 = _a.sent();
                        if (this.onPurchaseRejected) {
                            this.onPurchaseRejected(this.purchase, e_1.message);
                        }
                        throw new PurchaseError(e_1.message, this.purchase);
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Create the purchase and return paymentintent
     */
    PurchaseAttempt.prototype.createPurchaseGetPaymentIntent = function () {
        return __awaiter(this, void 0, void 0, function () {
            var confirmedPurchase, e_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, OrderAPI.purchaseGetPaymentIntent(this.purchase)];
                    case 1:
                        confirmedPurchase = _a.sent();
                        return [2 /*return*/, confirmedPurchase];
                    case 2:
                        e_2 = _a.sent();
                        if (this.onPurchaseRejected) {
                            this.onPurchaseRejected(this.purchase, e_2.message);
                        }
                        throw new PurchaseError(e_2.message, this.purchase);
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Pay for purchase, and update back-end to inform of success or failure.
     */
    PurchaseAttempt.prototype.payForPurchase = function () {
        return __awaiter(this, void 0, void 0, function () {
            var result, e_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        result = null;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 11]);
                        return [4 /*yield*/, this.executePayment(this.purchase)];
                    case 2:
                        result = _a.sent();
                        return [3 /*break*/, 11];
                    case 3:
                        e_3 = _a.sent();
                        if (!(e_3 instanceof PurchaseError)) return [3 /*break*/, 9];
                        return [4 /*yield*/, this.reportPaymentFailure(e_3)];
                    case 4:
                        _a.sent();
                        _a.label = 5;
                    case 5:
                        _a.trys.push([5, , 7, 8]);
                        return [4 /*yield*/, OrderAPI.reportPaymentFailure(e_3)];
                    case 6:
                        _a.sent();
                        return [3 /*break*/, 8];
                    case 7:
                        e_3.notifyBugsnag();
                        if (this.onPurchaseRejected) {
                            this.onPurchaseRejected(this.purchase, e_3.message);
                        }
                        return [7 /*endfinally*/];
                    case 8: return [3 /*break*/, 10];
                    case 9:
                        //Unknown error.
                        console.log('Unknown error caught here.', e_3);
                        console.log("Error type", typeof e_3);
                        Bugsnag.notify(e_3);
                        if (this.onPurchaseRejected) {
                            this.onPurchaseRejected(this.purchase, 'Purchase Failed');
                        }
                        _a.label = 10;
                    case 10: throw e_3;
                    case 11: 
                    //2. Soft-confirm for back-end.
                    return [4 /*yield*/, this.confirmPayment(result)];
                    case 12:
                        //2. Soft-confirm for back-end.
                        _a.sent();
                        return [2 /*return*/, this];
                }
            });
        });
    };
    PurchaseAttempt.prototype.confirmPayment = function (result) {
        return __awaiter(this, void 0, void 0, function () {
            var e_4;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, OrderAPI.confirmPayment(result)];
                    case 1:
                        _a.sent();
                        if (this.onPurchaseSuccessful) {
                            this.onPurchaseSuccessful(this.purchase, 'Success');
                        }
                        return [3 /*break*/, 3];
                    case 2:
                        e_4 = _a.sent();
                        //ToDo: Payment was successful, but the back-end may not have been notified.
                        console.error(e_4);
                        Bugsnag.notify(e_4);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Report failure to back-end so that it can rollback the change.
     * Then notify bugsnag and rollback any changes.
     * @param e Returned purchase error.
     */
    PurchaseAttempt.prototype.reportPaymentFailure = function (e) {
        return __awaiter(this, void 0, void 0, function () {
            var ex_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, 3, 4]);
                        console.log("Reporting back to the backend that this purchase failed.");
                        return [4 /*yield*/, OrderAPI.reportPaymentFailure(e)];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 2:
                        ex_1 = _a.sent();
                        console.log('Something strange happening here...' + ex_1.message);
                        console.log(ex_1);
                        return [3 /*break*/, 4];
                    case 3:
                        e.notifyBugsnag();
                        if (this.onPurchaseRejected) {
                            this.onPurchaseRejected(this.purchase, e.message);
                        }
                        return [7 /*endfinally*/];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    PurchaseAttempt.prototype.redirect = function () {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function () {
            var guestCheckout, orderHasId, orderID;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        guestCheckout = ((_a = this.purchase.userId) !== null && _a !== void 0 ? _a : 0) === 0;
                        orderHasId = ((_b = this.purchase.orders[0].userId) !== null && _b !== void 0 ? _b : 0) === 0;
                        if (guestCheckout && orderHasId) {
                            window.location.href = '/checkout/success/guest';
                            return [2 /*return*/];
                        }
                        if (this.purchase.isSplit()) {
                            window.location.href = '/checkout/success/guest';
                            return [2 /*return*/];
                        }
                        orderID = 'guest';
                        return [4 /*yield*/, apiClient.getUserOrders(null).then(function (resp) {
                                var lastItem = resp.slice(-1)[0];
                                orderID = lastItem.id.toString();
                                return orderID;
                                // window.location.href = '/checkout/success/' + orderID;
                            }).catch(function (error) {
                                console.log(error);
                                window.location.href = '/checkout/success/guest';
                                return '-1';
                            })];
                    case 1: return [2 /*return*/, _c.sent()];
                }
            });
        });
    };
    return PurchaseAttempt;
}());
export { PurchaseAttempt };
